import React, { useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

const WhatsAppCampaign = () => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {
    if (!link) {
      alert("Please enter a link");
      return;
    }

    try {
      setLoading(true);
      setResult(null);

      const res = await axios.post(
        "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/campaign/whatsApp-service",
        { link },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "module-id": "notification_service", // ✅ IMPORTANT
          },
        }
      );

      setResult(res.data.response);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Campaign failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen md:ml-64 mt-28 bg-gray-100 p-4 sm:p-6">

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
          WhatsApp Campaign
        </h1>
        <p className="text-sm text-gray-500">
          Send bulk WhatsApp notifications to users
        </p>
      </div>

      {/* Card */}
      <div className="bg-white rounded-xl shadow-sm p-6 max-w-2xl">

        {/* Input */}
        <div className="mb-4">
          <label className="text-sm text-gray-600">
            Campaign Link
          </label>
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="https://example.com"
            className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`px-5 py-2 rounded-lg text-white text-sm ${
            loading
              ? "bg-gray-400"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {loading ? "Sending..." : "Send Campaign"}
        </button>

        {/* Result */}
        {result && (
          <div className="mt-6 bg-gray-50 p-4 rounded-lg text-sm space-y-2">
            <p><b>Message:</b> {result.message}</p>
            <p><b>Total:</b> {result.total}</p>
            <p className="text-green-600"><b>Success:</b> {result.success}</p>
            <p className="text-red-500"><b>Failed:</b> {result.failed}</p>
          </div>
        )}

      </div>
    </div>
  );
};

export default WhatsAppCampaign;